<template>
  <div class="charge-rule">
    <!-- <div class="content-left">
      <AreaTree ref="areaTree" v-on:handleTreeClick="handleTreeClick" :moduleName="moduleName"></AreaTree>
    </div> -->
    <div>
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float" @submit.prevent>
          <div class="form-group">
            <label for="a_name">物业：</label>
            <el-select
              class="check-property"
              filterable
              clearable
              v-model.trim="search.propertyId"
            >
              <el-option
                v-for="item in propertyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="form-group">
            <label for>规则名称:</label>
            <input
              clearable
              v-model="search.name"
              class="form-control"
              id
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <el-button
                @click="searchList"
                type="primary"
                :loading="loading"
                 size="small"
              >
                查询
              </el-button>
            </span>
            <span class="add_btn">
              <button
                type="button"
                class="btn btn-default"
                id="add_btn"
                @click="addOrEdit()"
              >
                添加
              </button>
            </span>
            <!-- <span class='refresh_btn'><Refresh @tableList="this.tableList"></Refresh></span> -->
          </div>
        </form>
      </div>
      <div class="list">
        <el-table
          ref="table"
          border
          :data="tableListData"
          height="100%"
          width="100%"
          v-loading="loading"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <!-- <el-table-column
            show-overflow-tooltip
            label="物业"
            prop="propertyName"
          ></el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            label="卡名称"
            prop="name"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="卡类型"
           
          >
        <template slot-scope="scope">
          <span>{{ scope.row.unitType==1?'月卡':'年卡' }}</span>
        </template>
        </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="适用车场"
            prop="parkingNames"
          ></el-table-column>
          
          <el-table-column
            show-overflow-tooltip
            label="费用(月)"
            prop="amount"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="生效日期"
            prop="crtTime"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="状态"
          >
          <template slot-scope="scope">
            {{ scope.row.status==0?'待发布':(scope.row.status==1?'已发布':(scope.row.status==2?'已下线':'')) }}
          </template>
        </el-table-column>
          <el-table-column show-overflow-tooltip label="操作" width="150px">
            <template slot-scope="scope">
              <button
                type="button"
            
                v-bind:class="[ 'edit',
                scope.row.status==1||scope.row.status==2 ? 'is-gray' : '',
               
              ]"
                @click="onReleaseBtn(scope.row.id)"
                :disabled="scope.row.status==1||scope.row.status==2"
              >
                发行
              </button>
              <button
                type="button"
                class="edit"
                @click="onDownlineBtn(scope.row.id)"
                v-bind:class="[ 'edit',
                scope.row.status==2 ? 'is-gray' : '',
               
              ]"
              :disabled="scope.row.status==2"
              >
                下线
              </button>
              <button
                type="button"
                class="edit"
                @click="addOrEdit(scope.row)"
              >
                修改
              </button>
              
              <button class="delete" @click="del(scope.row.id)">删除</button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Page v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>
    <!-- 添加/编辑收费规则-->
    <el-dialog
      title="添加/编辑收费规则"
      :visible.sync="dialogFormVisibleChargeRule"
      width="680px"
      :close-on-click-modal="false"
      :lock-scroll="false"
      destroy-on-close
      @close="closeDialog"
    >
      <el-form
        :rules="rules"
        :model="chargeRule"
        ref="formArea"
        label-position="right"
        label-width="100px"
      >
        <el-form-item label="会员卡名称" prop="name">
          <el-input v-model.trim="chargeRule.name" placeholder="请输入会员卡名称"></el-input>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="会员卡单位" prop="unitType">
              <el-select v-model="chargeRule.unitType" placeholder="请选择" style="width: 100%">
                <el-option
                  v-for="item in months"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                >{{ item.label }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="会员卡单价" prop="amount" class="price">
              <el-input v-model.trim="chargeRule.amount" placeholder="请输入单价"></el-input>
              <span class="price-suffix">元</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
        
          <el-col :span="12">
            <el-form-item label="可选车型" prop="carType">
              <el-checkbox-group v-model="checkedCarType">
                <el-checkbox
                  v-for="carType in carTypes"
                  :label="carType.value"
                  :key="carType.labelDefault"
                >{{ carType.labelDefault }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
            <el-col :span="12">
            <el-form-item label="欠费车主购买" prop="arrearsCanBuy" class="arrears-buy">
              <el-radio-group v-model="chargeRule.arrearsCanBuy">
                <el-radio :label="1">允许</el-radio>
                <el-radio :label="0">不允许</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="物业" prop="parentId">
          <el-select
            class="check-property"
            filterable
            clearable
            v-model="chargeRule.parentId"
            placeholder="请选择物业"
            style="width: 100%"
            @change="onPropertyChange"
          >
            <el-option
              v-for="item in propertyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="可停用车场" prop="parkingIds">
          <el-select
            multiple
            clearable
            v-model="chargeRule.parkingIds"
            v-loading="parkingLoading"
            placeholder="请选择可停用车场"
            style="width: 100%"
          >
            <el-option
              v-for="item in parkingsDataByProperty"
              :key="item.parkingId"
              :label="item.parkingName"
              :value="item.parkingId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="卡片说明" prop="instruction">
          <el-input
            type="textarea"
            :rows="3"
            v-model.trim="chargeRule.instruction"
            placeholder="请输入卡片说明"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户协议" prop="aggrement">
          <el-input
            type="textarea"
            :rows="3"
            v-model.trim="chargeRule.aggrement"
            placeholder="请输入用户协议"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleChargeRule = false">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="addEditTrue">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import {
  getMonthlyChargeRule,
  getOneMonthlyChargeRule,
  addMonthlyChargeRule,
  updateMonthlyChargeRule,
  getAllParkingsByEnabled,
  fetchPropertyList,
  dictValue,
  getParkingsByProperty,
  rentMonthPage,
  rentMonthRelease,
  rentMonthDownline
} from "@/api/url";

import Page from "../../commons/page";

import AreaTree from "../../commons/areaTree";

export default {
  name:'charge-rule',
  data() {
    return {
      moduleName: "parking",
      propertyList: [],
      tableListData: [],
      allParkings: [],
      dialogFormVisibleChargeRule: false,
      months: [{label:'月',value:1},{label:'年',value:2}],
      search: {
        pageSize: 10,
        pageNumber: 1,
        name: null,
        propertyId: null,
      },
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      chargeRule: {
        name: "",
        parentId: "", //物业Id
        amount: "",
        instruction: "",
        aggrement: "",
        months: "",
        unitType:"",
        parkingIds: [],
        arrearsCanBuy: 0,
        carType: [],
        id: "",
      },
      rules: {
        name: [{ required: true, message: "请填写规则名称", trigger: "blur" }],
        amount: [{ required: true, message: "请填写会员卡单价", trigger: "blur" }],
        unitType: [
          { required: true, message: "请选择会员卡单位", trigger: "change" },
        ],
        parentId: [
          {
            required: true,
            message: "请选择物业",
            trigger: ["blur", "change"],
          },
        ],
        parkingIds: [
          {
            required: true,
            type: "array",
            message: "请选择可停用车场",
            trigger: ["blur", "change"],
          },
        ],
      },
      checkedCarType: [],
      carTypes: [],
      parkingsDataByProperty: [],
      parkingLoading: false,
      pageObj:{},
      loading:false,
      submitLoading:false
    };
  },
  components: {
    Page,
    AreaTree,
  },
  computed: {
    ...mapState(["page"]),
  },
  mounted() {
    this.getAllProperty();

    this.getCarTypes();
    this.tableList(this.search.pageNumber);
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;

      this.tableList(this.search.pageNumber);
    },

    tableList(curPage) {
      var _this = this;
      this.loading = true;
      const { propertyId, pageSize, name } = this.search;
     return this.$get(rentMonthPage(), {
        enabledFlag: "y",
        parentId: propertyId ? propertyId : null,
        limit: pageSize,
        page: curPage,
        name: name ? name : null,
      }).then((data) => {
        if (data.status != 200) return;
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.pageObj={...pageObj}
        // _this.getPage(pageObj);
        const {
          data: { rows },
        } = data;
        _this.tableListData = rows.map((item) => {
          // if (item.parentId && typeof JSON.parse(item.parentId) === "object") {
          //   item.propertyName = JSON.parse(item.parentId).name;
          // }
          return item;
        });
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      }).finally(() => {
        _this.loading = false;
      });
    },
    addOrEdit(row) {
      
      this.dialogFormVisibleChargeRule = true;
      this.checkedCarType = [];
      if (!row) {
        this.chargeRule = this.initChargeRule();
        // 新增时默认全选所有车型
        this.checkedCarType = this.carTypes.map((item) => item.value);
      } else {
        this.chargeRule = { ...row };
        this.chargeRule.parkingIds = (row.parkingIds || "").split(",").filter(Boolean);
        this.checkedCarType = (row.carType || "").split(",").filter(Boolean);
        this.reqParkingsByProperty(this.chargeRule.parentId);
      
        // this.$get(getOneMonthlyChargeRule() + "/" + id).then((res) => {
        //   const {
        //     status,
        //     data
        //   } = res;
        //   if (status !== 200) return;
        //   this.chargeRule = {
        //   ...data
        //   };
        // });
      }
    },
    addEditTrue() {
      this.$refs["formArea"].validate((valid) => {
        if (!valid) return;
        const currentChargeRules = JSON.parse(
          JSON.stringify(this.chargeRule)
        );
        currentChargeRules.parkingIds = (currentChargeRules.parkingIds || []).join(",");
        currentChargeRules.carType = this.checkedCarType.join(",");
        if (currentChargeRules.unitType == 1) currentChargeRules.months = 1;
        else if (currentChargeRules.unitType == 2) currentChargeRules.months = 12;
        this.submitLoading = true;
        if (this.chargeRule.id) {
          this.$putRequest(
            updateMonthlyChargeRule() + "/" + this.chargeRule.id,
            { ...currentChargeRules }
          ).then((data) => {
            if (data.status != 200) {
              this.$message({ type: "error", message: "修改失败，请稍后重试" });
              return;
            }
            this.$notify({
              type: "success",
              title: "成功",
              message: "月年租卡修改成功!",
            });
            this.dialogFormVisibleChargeRule = false;
            this.tableList(this.search.pageNumber);
          }).finally(() => {
            this.submitLoading = false;
          });
        } else {
          this.$postRequest(addMonthlyChargeRule(), {
            ...currentChargeRules,
          }).then((data) => {
            if (data.status != 200) {
              this.$message({ type: "error", message: "新增失败，请稍后重试" });
              return;
            }
            this.$notify({
              type: "success",
              title: "成功",
              message: "月年租卡设置成功!",
            });
            this.search.pageNumber = 1;
            this.tableList(this.search.pageNumber);
            this.dialogFormVisibleChargeRule = false;
          }).finally(() => {
            this.submitLoading = false;
          });
        }
      });
    },
    del(id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function() {
          _this.$layer.close(index);
          _this
            .$deleteRequest(getOneMonthlyChargeRule() + "/" + id)
            .then((data) => {
              if (data.status != 200)
                return _this.$layer.msg("删除失败", { time: 1 });
              _this.$notify({
                type: "success",
                title: "成功",
                message: "删除成功!",
              });
              _this.tableList(_this.search.pageNumber);
            });
        }
      );
    },
    allParking() {
      this.$get(getAllParkingsByEnabled()).then((data) => {
        if (data.status != 200) return;
        this.allParkings = data.data.rows;
      });
    },
    searchList:function() {
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    // resetForm() {
    //   this.$refs["formArea"].resetFields();
    // },
    closeDialog() {
      this.chargeRule = this.initChargeRule();
      this.checkedCarType = [];
      this.parkingsDataByProperty = [];
      this.$nextTick(() => {
        this.$refs["formArea"] && this.$refs["formArea"].clearValidate();
      });
    },
    getAllProperty() {
      this.$get(fetchPropertyList()).then((data) => {
        if (data.status === 200) {
          this.propertyList = data.data;
        }
      });
    },
    getCarTypes() {
      this.$get(`${dictValue()}/car_type`).then((data) => {
     
        this.carTypes = data?.data?.rows ?? [];
        // 新增模式下若弹窗已打开，默认全选（兜底）
        if (this.dialogFormVisibleChargeRule && !this.chargeRule.id) {
          this.checkedCarType = this.carTypes.map((item) => item.value);
        }
      });
    },
    reqParkingsByProperty(id) {
      this.parkingLoading = true;
      this.$get(getParkingsByProperty(), {
        parentId: id,
      }).then((data) => {
        if (data.status != 200) {
          return;
        }
        this.parkingsDataByProperty = data?.data ?? {};
      }).finally(() => {
        this.parkingLoading = false;
      });
    },
    onPropertyChange(id) {
      this.chargeRule.parkingIds = [];
      this.reqParkingsByProperty(id);
    },
    initChargeRule() {
      return {
        name: "",
        parentId: "", //物业Id
        amount: "",
        instruction: "",
        aggrement: "",
        months: "",
        parkingIds: [],
        unitType: "",
        arrearsCanBuy: 0,
        carType: [],
        id: "",
      };
    },
    onReleaseBtn(id){
      this.$postRequest(rentMonthRelease(),{
        id
      }).then(data=>{
       if(data?.status==200)  { 
         this.$message({
						message: '发布成功！',
						type: 'success'
						});
            this.tableList(this.search.pageNumber);
            return;
					}
        if(data?.status!=200){
          this.$message({
						message: '发布失败！',
						type: 'warning'
						});
            return;
        }
      })
    },
    onDownlineBtn(id){
      this.$postRequest(rentMonthDownline(),{
        id
      }).then(data=>{
       if(data?.status==200)  { 
         this.$message({
						message: '下线成功！',
						type: 'success'
						});
            this.tableList(this.search.pageNumber);
            return;
					}
        if(data?.status!=200){
          this.$message({
						message: '下线失败！',
						type: 'warning'
						});
            return;
        }
      })
    }
  },
};
</script>
<style scoped>
.charge-rule .is-gray{
  cursor: not-allowed;
  color:#aaa !important;
}
</style>
<style>
.charge-rule .price .el-form-item__content {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.charge-rule .price .el-input {
  flex: 1;
}
.charge-rule .price .price-suffix {
  margin-left: 8px;
  color: #666;
  white-space: nowrap;
}
.charge-rule .el-radio-group {
  margin-top: 0;
}
.charge-rule .arrears-buy .el-form-item__content {
  display: flex;
  align-items: center;
  min-height: 34px;
}

</style>
